export default __webpack_public_path__ + "static/media/customer-service.833de3a6.png";